(function () {
  'use strict';

  // Roda em qualquer página onde a section conso-outlet-rewrite for incluída.
  // Hoje só está em templates/collection.outlet.json — se for adicionada em
  // outras templates (home, landing), o rewrite passa a valer ali também.

  var SUFFIX_KEY = 'view=outlet';
  var PRODUCT_RE = /^(?:https?:\/\/[^/]+)?\/products\//;

  function ensureViewOutlet(href) {
    if (!href) return href;
    if (!PRODUCT_RE.test(href)) return href;
    if (href.indexOf('view=outlet') !== -1) return href;
    var sep = href.indexOf('?') !== -1 ? '&' : '?';
    return href + sep + SUFFIX_KEY;
  }

  function rewriteLink(a) {
    if (!a || a.tagName !== 'A') return;
    var href = a.getAttribute('href');
    var next = ensureViewOutlet(href);
    if (next !== href) a.setAttribute('href', next);
  }

  function rewriteAllInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    var links = root.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) rewriteLink(links[i]);
  }

  // Captura o click ANTES dos handlers do app — se o app navega via href,
  // já vai com view=outlet. Se o app navega via JS (window.location.assign),
  // ainda precisa do path B (interceptação navigation, mais abaixo).
  function onClickCapture(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var a = target.closest('a[href*="/products/"]');
    if (a) rewriteLink(a);
  }

  function init() {
    rewriteAllInRoot(document.body);

    document.addEventListener('click', onClickCapture, true);
    document.addEventListener('mousedown', onClickCapture, true);
    document.addEventListener('auxclick', onClickCapture, true);
    document.addEventListener('touchstart', onClickCapture, true);

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (!node || node.nodeType !== 1) continue;
            if (node.tagName === 'A') {
              rewriteLink(node);
            } else {
              rewriteAllInRoot(node);
            }
          }
        } else if (m.type === 'attributes' && m.attributeName === 'href' && m.target) {
          rewriteLink(m.target);
        }
      }
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
